/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import {FormattedTime} from 'react-intl';

const LocalTime = ({ data }) => (
    data ? <FormattedTime
        value={data}
    /> : null
);

export default LocalTime;


/** WEBPACK FOOTER **
 ** ./src/components/LocalTime.jsx
 **/